module.exports = __webpack_public_path__ + "img/vk.7909bc41.svg";